import React, { useEffect, useState } from "react";
import NavBar from "../components/Navigation/NavBar";
import { getConfig, getConstant, getPlanAmount, getPlanLabel, handleHeader, handleHrefRedirect } from "../services/functions";
import { ABOUT_US_PATH, BASE_URL, CONTACT_US_PATH, PRIVACY_POLICY_PATH } from "../utility/path";
import axios from "axios";
import MainContainer from "../components/MainContainer";
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import CustomIcon from "../components/CustomIcon";
import "../TnC.css";

const TnC = () => {
    const [state, setState] = useState([]);
    const dispatch = useDispatch();


    useEffect(() => {
        handleHeader({ ...getConstant("TNC") }, dispatch);
        //loadData();

    }, []);

    const loadData = async () => {
        const data = JSON.parse(localStorage.getItem("aboutus"));
        if (data && data?.length > 0) {
            setState(data);
            return;
        }

        try {
            const config = getConfig();
            const res = await axios.get(`${BASE_URL}/api/aboutus`, config);
            if (res?.data?.paras) {
                localStorage.setItem("aboutus", JSON.stringify(res.data.paras));
                setState(res.data.paras);
            }

        } catch (error) {
            console.log(error?.message)
        }
    }

    return (

        <>
            <NavBar />
            <MainContainer>
                <div className="tnc-page">
                    <div className="tnc-hero">
                        <div className="tnc-hero__icon">
                            <i className="fa fa-file-text" />
                        </div>
                        <h3 className="tnc-hero__title">Terms & Conditions</h3>
                        <p className="tnc-hero__sub">Last updated: April 2026</p>
                    </div>

                    <div className="tnc-section">
                        <div className="tnc-section__heading"><span className="tnc-section__num">1</span>Introduction</div>
                        <div className="tnc-section__body">
                            Welcome to "Gaufi" ("the Platform"). "Gaufi" is designed, developed, maintained and owned by <a href="#" onClick={() => handleHrefRedirect("https://www.softneering.com/")}>Softneering Technology Solutions Private Limited</a>. By accessing or using our Platform, you agree to comply with and be bound by these Terms and Conditions ("Terms").
                            If you do not agree to these Terms, you should not use the Platform.
                        </div>
                    </div>

                    <div className="tnc-section">
                        <div className="tnc-section__heading"><span className="tnc-section__num">2</span>Description of Services</div>
                        <div className="tnc-section__body">The Platform provides a service that helps users ("Users") to search and connect with nearby freelance professionals ("Professionals") such as carpenters, electricians, etc.
                            The Platform serves as a facilitator and is not responsible for the services provided by the Professionals.</div>
                    </div>

                    <div className="tnc-section">
                        <div className="tnc-section__heading"><span className="tnc-section__num">3</span>User Responsibilities</div>
                        <div className="tnc-section__body"><b>Use of Services:</b> Users are solely responsible for deciding whether to engage with the Professionals listed on the Platform.
                            <br />
                            <b>Verification:</b> Users should independently verify the credentials and qualifications of any Professional before hiring them.
                            <br />
                            <b>Conduct:</b> Users agree to use the Platform in a lawful manner and not to engage in any conduct that could harm the reputation or functionality of the Platform.</div>
                    </div>

                    <div className="tnc-section">
                        <div className="tnc-section__heading"><span className="tnc-section__num">4</span>Professional Account Creation</div>
                        <div className="tnc-section__body">
                            <b>Registration:</b> Professionals can create an account by providing minimum required information, including name, contact details, and profession.
                            <br />
                            <b>Accuracy of Information:</b> Professionals must ensure that the information provided is accurate and up-to-date.
                            <br />
                            <b>Subscription Plans:</b> Professionals can opt for various subscription plans that may offer additional benefits and help them get more business opportunities.
                        </div>
                    </div>


                    <div className="tnc-section">
                        <div className="tnc-section__heading"><span className="tnc-section__num">5</span>Subscription Plans Options</div>
                        <div className="tnc-section__body">
                            The Platform offers different subscription plans for Professionals, which may include but are not limited to.
                            <br />
                            <b>{getPlanLabel(1)}:</b> Access to the Platform with limited features. Just pay <b><CustomIcon type="currency" />{getPlanAmount(1)}</b> for one year validity.
                            <br />
                            <b>{getPlanLabel(2)}:</b> Enhanced visibility and access to additional features. Just pay <b><CustomIcon type="currency" />{getPlanAmount(2)}</b> for two years validity.
                            <br />
                            <b>{getPlanLabel(3)}:</b> Maximum visibility and access to all features, including priority support. Just pay <b><CustomIcon type="currency" />{getPlanAmount(3)}</b> for three years validity.
                        </div>
                    </div>

                    <div className="tnc-section">
                        <div className="tnc-section__heading"><span className="tnc-section__num">6</span>Subscription Fees</div>
                        <div className="tnc-section__body">
                            <b>Payment:</b> Subscription fees are charged as per the selected plan and are required to keep the Platform operational.
                            <br />
                            <b>Payment Methods:</b> The Platform accepts various payment methods including credit/debit cards and online payment services.
                            <br />
                            <b>Changes to Fees:</b> The Platform reserves the right to change subscription fees at any time. Any fee change will become effective at the end of the current billing cycle. Professionals will be notified in advance of any changes to the fees.
                        </div>
                    </div>
                    <div className="tnc-section">
                        <div className="tnc-section__heading"><span className="tnc-section__num">7</span>Cancellation and Refunds</div>
                        <div className="tnc-section__body">
                            Cancellation and Refunds Policy:
                            <ul>
                                <li><b>Cancellation:</b> Professionals can cancel their subscription at any time by contacting us. <b>(Note: Cancellation of the subscription does not automatically delete the account.)</b>.</li>
                                <li><b>Refund Policy:</b> Subscription fees are generally non-refundable. <b>Account deletion does not qualify a Professional for a refund for any prepaid period.</b></li>
                            </ul>
                        </div>
                    </div>
                    <div className="tnc-section">
                        <div className="tnc-section__heading"><span className="tnc-section__num">8</span>Platform's Role and Liability</div>
                        <div className="tnc-section__body">
                            <b>Facilitation:</b> The Platform acts as a facilitator connecting Users with Professionals and does not endorse or guarantee the quality of services provided by Professionals.
                            <br />
                            <b>No Warranty:</b> The Platform is provided "as is" and "as available" without any warranties of any kind, either express or implied.
                            <br />
                            <b>Liability:</b> The Platform is not liable for any direct, indirect, incidental, or consequential damages arising out of or related to the use of the Platform or services provided by Professionals.
                        </div>
                    </div>
                    <div className="tnc-section">
                        <div className="tnc-section__heading"><span className="tnc-section__num">9</span>Termination and Account Deletion</div>
                        <div className="tnc-section__body">
                            <b>Termination by User:</b>
                            <ul>
                                <li><b className="ms-3 mt-3">General Users:</b> Users may terminate their account at any time by navigating to Profile Page and click on <b>Delete Account</b> button. </li>
                                <li><b className="ms-3">Professionals:</b> Professionals may terminate their account; however, account deletion does not constitute a refund for any active, prepaid subscription plan (refer to Section 7).</li>
                            </ul>
                            <b className="mt-3">Consequences of Termination/Deletion:</b>
                            <ul>
                                <li><b className="ms-3">Loss of Access:</b> Upon termination, whether by the User or the Platform, your account access will be immediately revoked.</li>
                                <li><b className="ms-3">Irrevocability:</b> Account deletion is <b>permanent and irreversible</b>. All user data, saved searches, and usage history will be permanently erased (subject to the data retention exceptions outlined in our <b>Privacy Policy, Section 6A</b>).</li>
                                <li><b className="ms-3">Forfeiture:</b> Any remaining days on a Professional's subscription, accrued benefits, or unused credits will be <b>immediately forfeited</b> upon deletion and are non-refundable.</li>
                            </ul>
                            <ul>
                                <li><b>Conditions for Deletion:</b> The Platform reserves the right to delay or reject an account deletion request if the account has any outstanding financial obligations, unresolved disputes, or pending legal investigations.</li>
                            </ul>
                            <ul>
                                <li><b>Termination by Platform:</b> The Platform reserves the right to terminate or suspend any account at its discretion, particularly in cases of violation of these Terms.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="tnc-section">
                        <div className="tnc-section__heading"><span className="tnc-section__num">10</span>Changes to Terms</div>
                        <div className="tnc-section__body">
                            The Platform reserves the right to terminate or suspend any account at its sole discretion, particularly in cases of violation of these Terms, illegal conduct, or misuse of the Platform's services.
                        </div>
                    </div>
                    <div className="tnc-section">
                        <div className="tnc-section__heading"><span className="tnc-section__num">11</span>Governing Law</div>
                        <div className="tnc-section__body">
                            These Terms shall be governed by and construed in accordance with the laws of India.
                        </div>
                    </div>
                    <div className="tnc-section">
                        <div className="tnc-section__heading"><span className="tnc-section__num">12</span>Privacy Policy</div>
                        {/* We strongly recommend to refer to <a href="#" onClick={()=>handleHrefRedirect("https://www.gaufi.com/privacy.html")}>Privacy Policy</a>. */}
                        <div className="tnc-section__body">
                            We strongly recommend to refer to <NavLink to={PRIVACY_POLICY_PATH}>Privacy Policy</NavLink>.
                        </div>
                    </div>
                    <div className="tnc-section">
                        <div className="tnc-section__heading"><span className="tnc-section__num">13</span>About Us</div>
                        <div className="tnc-section__body">
                            Know more <NavLink to={ABOUT_US_PATH}>about us</NavLink>.
                        </div>
                    </div>
                    <div className="tnc-section">
                        <div className="tnc-section__heading"><span className="tnc-section__num">14</span>Contact Information</div>
                        <div className="tnc-section__body">
                            For any questions or concerns about these Terms, please contact us at <NavLink to={CONTACT_US_PATH}>Contact us</NavLink>.
                        </div>
                    </div>

                    {/* Bottom links */}
                    <div className="tnc-links">
                        <NavLink to={PRIVACY_POLICY_PATH} className="tnc-link">
                            <i className="fa fa-shield" /> Privacy Policy
                        </NavLink>
                        <NavLink to={ABOUT_US_PATH} className="tnc-link">
                            <i className="fa fa-info-circle" /> About Us
                        </NavLink>
                        <NavLink to={CONTACT_US_PATH} className="tnc-link">
                            <i className="fa fa-envelope" /> Contact Us
                        </NavLink>
                    </div>

                </div>
            </MainContainer>
        </>
    );
};

export default TnC;
